import { render } from "./ToolBarVistaHistorial.vue?vue&type=template&id=451745d0"
import script from "./ToolBarVistaHistorial.vue?vue&type=script&lang=js"
export * from "./ToolBarVistaHistorial.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__